import _ from 'lodash';
import Model from '../model';

/**
 * Registration Model
 * @property registration_token
 * @property form_type
 * @property first_name
 * @property last_name
 * @property email
 * @property telephone
 * @property post_code
 * @property security_question
 * @property security_answer
 * @property password
 * @property password_confirm
 * @property fields
 * @property __className
 */
export default class RegistrationModel extends Model {
  /**
   * Registration Model Constructor
   * add a 'fields' property which holds form-field types and validation information
   * @param {Object} registration
   * @param {Object} formConfiguration
   * @param {String} token
   */
  constructor(registration, formConfiguration, token) {
    super(registration);

    this.__className = 'RegistrationModel';

    this.registration_token = token;
    this.group_slug = null;

    // Set additional config on the provided form fields.
    const config = {
      company_name: {
        class: 'col-md-6',
      },
      last_name: {
        class: 'col-md-6',
      },
      email: {
        class: 'col-md-6',
      },
      postcode: {
        class: 'col-md-6',
      },
      security_question: {
        class: 'col-md-6',
      },
      security_answer: {
        class: 'col-md-6',
      },
    };

    // If field isn't in above we provide at least the class to preserve formatting.
    const configDefault = {
      class: 'col-md-6',
    };

    const configMerge = (aConfig, key) => Object.assign(config[key] || configDefault, aConfig);

    this.fields = {};

    this.fields = {
      password: {
        type: 'password',
        validation: 'required',
        class: 'col-md-6',
      },
      password_confirm: {
        type: 'password',
        validation: 'required',
        class: 'col-md-6',
      },
      ...this.fields,
    };

    this.fields = Object.assign(
      _.mapValues(formConfiguration, configMerge),
      this.fields,
    );
  }

  /**
   * Set the dealer slug on the model.
   *
   * @param {string} groupSlug
   */
  setDealerSlug(groupSlug) {
    this.group_slug = groupSlug;
  }

  setRecaptchaToken(token) {
    this.recaptcha_token = token;
  }
}
